module.exports = {"620922100":"渊泉镇","620922101":"柳园镇","620922102":"三道沟镇","620922103":"南岔镇","620922104":"锁阳城镇","620922105":"瓜州镇","620922106":"西湖镇","620922107":"河东镇","620922108":"双塔镇","620922109":"腰站子东乡族镇","620922201":"布隆吉乡","620922212":"七墩回族东乡族乡","620922214":"广至藏族乡","620922215":"沙河回族乡","620922216":"梁湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620922.json
// module id = 3073
// module chunks = 0